import { Box, Typography } from '@mui/material';
import type { JobOrderSpec } from '../../../utils/jobOrder';
import { PRINT_BORDER } from '../printStyles';
import LabelCell from './LabelCell';
import SizeRow from './SizeRow';
import TypeDesignRow from './TypeDesignRow';
import { summaryCellSx, summaryValueSx } from './styles';

type JobOrderSummaryProps = Pick<
  JobOrderSpec,
  'customerName' | 'title' | 'designCode' | 'size'
>;

const JobOrderSummary = ({
  customerName,
  title,
  designCode,
  size,
}: JobOrderSummaryProps) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'max-content minmax(0, 1fr)',
      containerType: 'inline-size',
    }}
  >
    <LabelCell sx={{ borderBottom: PRINT_BORDER }}>Customer</LabelCell>
    <Box
      sx={{
        ...summaryCellSx,
        gridColumn: '2 / -1',
        borderBottom: PRINT_BORDER,
      }}
    >
      <Typography sx={{ ...summaryValueSx, overflowWrap: 'break-word' }}>
        {customerName}
      </Typography>
    </Box>

    <TypeDesignRow title={title} designCode={designCode} />
    <SizeRow size={size} />
  </Box>
);

export default JobOrderSummary;
